<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" sm="6" class="text-center display-4">
        <h2>404</h2>
      </v-col>

      <v-col cols="12" sm="6" class="text-center text-sm-left">
        <v-card-text>
          <h1>Página no encontrada</h1>
        </v-card-text>

        <v-card-text>
          Lo sentimos, pero la página que busca no existe o no se puede encontrar.
        </v-card-text>

        <v-card-text>
          <v-btn @click="handleClick" color="primary">
            Volver al inicio
          </v-btn>
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  export default {
    name: 'NotFound',
    methods: {
      handleClick() {
        this.$router.push({name: 'estado_cuentas'})
      }
    }
  }
</script>

<style scoped>

</style>
